import React, { useContext, useMemo } from 'react'
import { useSearchParams, Navigate } from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Alert from 'react-bootstrap/Alert'
import Page from 'layout/page'
import PageTitle from 'layout/page-title'
import Tabs from '../duties/shared/tabs'
import UserContext from 'context/user-context'
import ReceiptManagement from '../receipt-scans/ReceiptManagement'

const INVOICE = 'invoice'
const RECEIPT = 'receipt'

const Upload = () => {
  const user = useContext(UserContext)
  const [searchParams, setSearchParams] = useSearchParams()

  const sectionAbbreviations = user?.section_abbreviations || []
  const hasAP = sectionAbbreviations.includes('AP')
  const hasPC = sectionAbbreviations.includes('PC')

  const availableTabs = useMemo(() => {
    const tabs = []
    if (hasAP) tabs.push({ name: 'Invoices', value: INVOICE })
    if (hasPC) tabs.push({ name: 'Receipts', value: RECEIPT })
    return tabs
  }, [hasAP, hasPC])

  if (!hasAP && !hasPC) {
    return <Navigate replace to="/dashboards" />
  }

  const requestedType = searchParams.get('type')
  const defaultType = hasAP ? INVOICE : RECEIPT
  const activeType = availableTabs.some((t) => t.value === requestedType)
    ? requestedType
    : defaultType

  const handleTabChange = (value) => {
    setSearchParams({ type: value }, { replace: true })
  }

  return (
    <Page title="Upload">
      <PageTitle />
      {hasAP && hasPC && (
        <Row className="mb-3">
          <Col xs={12}>
            <div className="text-primary fw-bold mb-1">Upload</div>
            <p className="text-muted small mb-0">
              Upload invoices or receipts and match them to existing AP or P-Card transactions.
            </p>
          </Col>
        </Row>
      )}

      {availableTabs.length > 1 && (
        <Row className="mb-3">
          <Col xs={12} sm={6}>
            <Tabs
              tabs={availableTabs}
              activeTab={activeType}
              setActiveTab={handleTabChange}
            />
          </Col>
        </Row>
      )}

      <Row>
        <Col>
          {activeType === INVOICE && hasAP && (
            <ReceiptManagement scanType="invoice" />
          )}
          {activeType === RECEIPT && hasPC && (
            <ReceiptManagement scanType="receipt" />
          )}
          {availableTabs.length === 0 && (
            <Alert variant="info">
              You do not have access to upload invoices or receipts.
            </Alert>
          )}
        </Col>
      </Row>
    </Page>
  )
}

export default Upload
